import {
  UseFormRegister,
  FieldErrors,
  UseFormWatch,
  UseFormUnregister,
} from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";
import Compare from "./Compare";
import Inputs from "./Inputs";

interface IModalHeader {
  register: UseFormRegister<FormTypes>;
  unregister: UseFormUnregister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  watch: UseFormWatch<FormTypes>;
  nextStep: Function;
  setAnyStep: Function;
  step: number;
  compareItemArray: Array<any>;
  handleCheckboxChange: Function;
  handleCheckNone: Function;
  selectedItemsToCompare: Array<any>;
  itemToConfigure: any;
  setItemToConfigure: Function;
  formData: any;
  setValue: Function;
  setDataCheckingModeHandler: Function;
  dataCheckingMode: boolean;
  trigger: Function;
  onBlurHandler: (event: any) => void;
  externalForceCount: number;
  setExternalForceCount: Function;
  momentsCount: number;
  setMomentsCount: Function;
}

function ModalFormWrapper(props: IModalHeader) {
  const {
    register,
    unregister,
    errors,
    watch,
    nextStep,
    step,
    compareItemArray,
    handleCheckboxChange,
    handleCheckNone,
    selectedItemsToCompare,
    formData,
    setItemToConfigure,
    itemToConfigure,
    setAnyStep,
    setValue,
    setDataCheckingModeHandler,
    dataCheckingMode,
    trigger,
    onBlurHandler,
    externalForceCount,
    setExternalForceCount,
    momentsCount,
    setMomentsCount,
  } = props;

  return (
    <div className="modal-form-wrapper">
        {step === 1 ? (<Inputs
          register={register}
          unregister={unregister}
          errors={errors}
          watch={watch}
          nextStep={nextStep}
          compareItemArray={compareItemArray}
          handleCheckboxChange={handleCheckboxChange}
          handleCheckNone={handleCheckNone}
          selectedItemsToCompare={selectedItemsToCompare}
          formData={formData}
          setItemToConfigure={setItemToConfigure}
          setAnyStep={setAnyStep}
          setValue={setValue}
          setDataCheckingModeHandler={setDataCheckingModeHandler}
          dataCheckingMode={dataCheckingMode}
          trigger={trigger}
          onBlurHandler={onBlurHandler}
          externalForceCount={externalForceCount}
          setExternalForceCount={setExternalForceCount}
          momentsCount={momentsCount}
          setMomentsCount={setMomentsCount}
          travelDistance={formData.travelDistance}
        />
      ) : step === 2 ? (
        <Compare
          register={register}
          errors={errors}
          watch={watch}
          selectedItemsToCompare={selectedItemsToCompare}
          travelDistance={formData.travelDistance}
        />
      ) : null}
    </div>
  );
}

export default ModalFormWrapper;
